var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFramevehicle2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5500_63913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30Z",
    fill: "#5FC79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79956 16.957H19.0078V18.8667H2.79956V16.957Z",
    fill: "#A37714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70945 17.5527H15.566C16.291 17.5527 16.8804 18.1421 16.8804 18.8671H3.38921C3.3951 18.1421 3.9845 17.5527 4.70945 17.5527Z",
    fill: "#66480C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79971 7.50977H18.4834V16.9577H2.79971V7.50977Z",
    fill: "#C49622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0078 11.0996H21.937C22.55 11.0996 23.1158 11.4238 23.4223 11.9542L24.3948 13.6222C24.6188 14.0112 24.9842 14.2941 25.4203 14.412L26.9292 14.8363C27.6718 15.0426 28.1846 15.7204 28.1846 16.4925V18.8678H19.0078V11.0996Z",
    fill: "#C49622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0945 18.8659L22.5857 16.974C22.5857 16.974 24.3185 16.0074 26.4756 16.6321L27.3008 18.8659H21.0945Z",
    fill: "#080708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6662 17.3926H28.7979V18.8602H27.6662V17.3926Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0057 18.867L26.2218 16.9043H24.1531C23.3633 16.9043 22.6265 17.2992 22.1904 17.9593L21.5833 18.867H20.5106L21.3888 17.6057C21.9782 16.7452 22.9566 16.2383 23.9998 16.2383H26.77L27.6953 18.867H27.0057Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5715 22.4967C11.2564 22.4967 10.1904 21.4306 10.1904 20.1155C10.1904 18.8004 11.2564 17.7344 12.5715 17.7344C13.8866 17.7344 14.9526 18.8004 14.9526 20.1155C14.9526 21.4306 13.8866 22.4967 12.5715 22.4967Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5718 21.5302C11.7906 21.5302 11.1573 20.8969 11.1573 20.1157C11.1573 19.3345 11.7906 18.7012 12.5718 18.7012C13.353 18.7012 13.9863 19.3345 13.9863 20.1157C13.9863 20.8969 13.353 21.5302 12.5718 21.5302Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5715 20.7397C12.2265 20.7397 11.9468 20.46 11.9468 20.115C11.9468 19.7699 12.2265 19.4902 12.5715 19.4902C12.9166 19.4902 13.1963 19.7699 13.1963 20.115C13.1963 20.46 12.9166 20.7397 12.5715 20.7397Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9841 22.4967C5.66903 22.4967 4.60296 21.4306 4.60296 20.1155C4.60296 18.8004 5.66903 17.7344 6.9841 17.7344C8.29916 17.7344 9.36523 18.8004 9.36523 20.1155C9.36523 21.4306 8.29916 22.4967 6.9841 22.4967Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98439 21.5302C6.20316 21.5302 5.56985 20.8969 5.56985 20.1157C5.56985 19.3345 6.20316 18.7012 6.98439 18.7012C7.76562 18.7012 8.39893 19.3345 8.39893 20.1157C8.39893 20.8969 7.76562 21.5302 6.98439 21.5302Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98413 20.7397C6.63909 20.7397 6.35938 20.46 6.35938 20.115C6.35938 19.7699 6.63909 19.4902 6.98413 19.4902C7.32917 19.4902 7.60889 19.7699 7.60889 20.115C7.60889 20.46 7.32917 20.7397 6.98413 20.7397Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2004 22.4907C22.7975 22.4907 21.6602 21.3534 21.6602 19.9504C21.6602 18.5475 22.7975 17.4102 24.2004 17.4102C25.6034 17.4102 26.7407 18.5475 26.7407 19.9504C26.7407 21.3534 25.6034 22.4907 24.2004 22.4907Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2006 21.4591C23.3673 21.4591 22.6918 20.7836 22.6918 19.9502C22.6918 19.1169 23.3673 18.4414 24.2006 18.4414C25.0339 18.4414 25.7095 19.1169 25.7095 19.9502C25.7095 20.7836 25.0339 21.4591 24.2006 21.4591Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1964 11.6758C22.5087 11.7465 22.7858 11.9469 22.9508 12.2298L23.9233 13.8978C23.9763 13.9921 24.0353 14.0746 24.1001 14.1571H22.886L22.1964 11.6758Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8543 11.6465L22.5557 14.1573H19.5557V11.6465H21.8543Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4833 7.50977H19.0078V16.9577H18.4833V7.50977Z",
    fill: "#A37714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5345 7.50977H17.8882V16.9577H17.5345V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.12 7.50977H16.4736V16.9577H16.12V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7054 7.50977H15.0591V16.9577H14.7054V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2909 7.50977H13.6445V16.9577H13.2909V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8763 7.50977H12.23V16.9577H11.8763V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4618 7.50977H10.8154V16.9577H10.4618V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04724 7.50977H9.40088V16.9577H9.04724V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63855 7.50977H7.99219V16.9577H7.63855V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.224 7.50977H6.57764V16.9577H6.224V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80945 7.50977H5.16309V16.9577H4.80945V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3949 7.50977H3.74854V16.9577H3.3949V7.50977Z",
    fill: "#D8AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.177 20.5551C24.007 20.5551 23.8692 20.4173 23.8692 20.2473C23.8692 20.0773 24.007 19.9395 24.177 19.9395C24.347 19.9395 24.4849 20.0773 24.4849 20.2473C24.4849 20.4173 24.347 20.5551 24.177 20.5551Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 19.9248C24.588 19.9248 24.5073 19.8441 24.5073 19.7446C24.5073 19.6451 24.588 19.5645 24.6875 19.5645C24.787 19.5645 24.8677 19.6451 24.8677 19.7446C24.8677 19.8441 24.787 19.9248 24.6875 19.9248Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6587 20.9522C23.5592 20.9522 23.4785 20.8715 23.4785 20.772C23.4785 20.6725 23.5592 20.5918 23.6587 20.5918C23.7582 20.5918 23.8389 20.6725 23.8389 20.772C23.8389 20.8715 23.7582 20.9522 23.6587 20.9522Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6587 19.9248C23.5592 19.9248 23.4785 19.8441 23.4785 19.7446C23.4785 19.6451 23.5592 19.5645 23.6587 19.5645C23.7582 19.5645 23.8389 19.6451 23.8389 19.7446C23.8389 19.8441 23.7582 19.9248 23.6587 19.9248Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 20.9522C24.588 20.9522 24.5073 20.8715 24.5073 20.772C24.5073 20.6725 24.588 20.5918 24.6875 20.5918C24.787 20.5918 24.8677 20.6725 24.8677 20.772C24.8677 20.8715 24.787 20.9522 24.6875 20.9522Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.728 18.4785C24.728 18.8237 24.4482 19.1035 24.103 19.1035C23.7578 19.1035 23.478 18.8237 23.478 18.4785C23.478 18.1333 23.7578 17.8535 24.103 17.8535C24.4482 17.8535 24.728 18.1333 24.728 18.4785Z",
    fill: "#4F5565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5500_63913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "matrix(-1 0 0 1 30 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramevehicle2);
export default __webpack_public_path__ + "static/media/Framevehicle2.5f1a4500cfb08069ecca404577b3c0be.svg";
export { ForwardRef as ReactComponent };